import { FieldTypeTextParentService } from './../utils/field-type-text-parent.service';
import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';

import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';
import { DocumentActionsService } from '@shared/services/document-actions/document-actions.service';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfTranslateDirective } from '../../../modules/translate/directive/af-translate.directive';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';
import { TooltipLawComponent } from '../../tooltip-law/tooltip-law.component';
import { TooltipInfoComponent } from '../../tooltip-info/tooltip-info.component';
import { NgShowDirective } from '../../../directives/ng-show/ng-show.directive';
import { NgClass } from '@angular/common';
import { ProgressBarDirective } from '@shared/directives/progress-bar/progress-bar.directive';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { TooltipInReportComponent } from "../../tooltip-in-report/tooltip-in-report.component";
import { FieldReferencesComponent } from "../../../../core/components/field-references/field-references.component";
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { UserPermisionsFactory } from '@shared/factories/user-permisions/user-permisions.factory';
import { SpanTooltipComponent } from "../../span-tooltip/span-tooltip.component";


@Component({
    selector: 'field-type-text-multiline',
    templateUrl: './field-type-text-multiline.component.html',
    standalone: true,
    imports: [NgClass,
    NgShowDirective,
    TooltipInfoComponent,
    TooltipLawComponent,
    TooltipModule,
    FormsModule,
    AfTranslateDirective,
    AfTranslatePipe,
    ProgressBarDirective,
    TooltipInReportComponent,
    FieldReferencesComponent, SpanTooltipComponent]
})
export class FieldTypeTextMultilineComponent implements OnChanges{
  isLanding: boolean = this.customLanding.isLanding();
  skin: string = this.globalCfg.skin;
  id: any = this.commonUtilsService.createId();
  interval: any;
  initInterval: number = 0;
  percentTime:number = 0;
  startAudio: boolean = false;
  permissions: string = this.userPermissions.getTypePermissions();

  fieldTypeText: any = {
    openLaw: false,
    inputText: '',
    titleField: '',
    minHeight:'',
    acceptAceptation: false,
    hasVoiceRecord: false,
    showReferences: false,
    voiceRecord:{}
  }

  constructor(private globalCfg: GlobalCfgFactory,
    private translate: AfTranslateFactory,
    private commonUtilsService: CommonUtilsService,
    private customLanding: CustomLandingFactory,
    private documentActions: DocumentActionsService,
    private fieldTypeTextParent: FieldTypeTextParentService,
    private apiService: ApiServiceService,
    private modalService: ModalServiceService,
    private userPermissions: UserPermisionsFactory) {}

  @Input() field : any ={};
  @Input() preSelectItem : any ='';
  @Input() concept : any ={};
  @Output() itemSelected = new EventEmitter();
  @Output() openRelatedInfo = new EventEmitter();
  @Output() saveVoiceRecord = new EventEmitter();


  ngOnChanges(): void {
    this.fieldTypeTextParent.configureChanges(this);
  }

  changeInField(){
    this.fieldTypeTextParent.changeInField(this)
  }

  analyzeWithSibila() {
    if(this.fieldTypeText.inputText.trim() !== ''){
        this.documentActions.doAction({ action: 'sibila', file: { text: this.commonUtilsService.jsonEncode(this.fieldTypeText.inputText) } });
    }
  }

  openTextareaModal(){
    this.modalService.expandTextarea(this.fieldTypeText.inputText, this.field, this.concept, this.fieldTypeText.voiceRecord, this.fieldTypeText.acceptAceptation)
      .subscribe((result:any)=>{
        if(result.result === 'ok'){
          this.fieldTypeText.inputText = result.inputText;
          this.fieldTypeTextParent.changeInFieldEmit(result.inputText, false, this);
          if(result.voiceRecord){
            this.configureRecordAudio(result.voiceRecord);
          }
          this.fieldTypeText.acceptAceptation = result.acceptAceptation;
        }
      })
  }

  showReference(e: any){
    this.fieldTypeTextParent.showReference(e, this);
  }

  openModalRelatedInfo(fieldRelatedInfo:any, e: any){
    this.fieldTypeTextParent.openModalRelatedInfo(e, fieldRelatedInfo, this)
  }

  openRecordVoice(){
    if(!this.field.noEditable){
      if(this.fieldTypeText.voiceRecord.player){
        this.modalService.infoModal({text: this.translate.instant('record-audio-modal.new-record-question'), typeButtons: 'questionRecord' })
          .subscribe((result:any)=>{
            if(result.result ==='ok'){
              this.recordVoice();
            }
          })

      }else{
        this.recordVoice();
      }
    }
  }

  recordVoice(){
    this.modalService.recordAudioModal(this.concept)
    .subscribe((result:any)=>{
      if(result.result ==='ok'){
        this. configureRecordAudio(result);
      }
    })
  }

  configureRecordAudio(result:any){
    this.fieldTypeText.hasVoiceRecord = true;
    this.fieldTypeText.voiceRecord = {
      player: result.player,
      maxTime: result.maxTime,
      text: result.text,
      secondsRecord: result.secondsRecord,
      name: result.name,
      recordingFile: result.recordingFile,
      file: result.file
    }
    this.fieldTypeText.audioLoaded = true;
    this.fieldTypeText.inputText = result.text;
    this.itemSelected.emit({newValue: result.text, addEnter:false});
    this.saveVoiceRecord.emit({
      acceptAceptation: this.fieldTypeText.acceptAceptation,
      voiceRecordFile: this.fieldTypeText.voiceRecord.file,
      name: this.fieldTypeText.voiceRecord.name
    })
  }

  playRecordVoice(){
    this.startAudio = !this.startAudio;
    if(!this.fieldTypeText.audioLoaded){
      this.getAudio()
    }else{
      if(this.startAudio){
        this.initInterval = 0;
        this.initStartAudio()
      }else{
        this.stopInterval();
      }
    }
  }

  resetInput(){
    if(this.startAudio){
      this.stopInterval()
    }
    this.fieldTypeText.acceptAceptation = false;
    this.fieldTypeText.hasVoiceRecord = false
    this.fieldTypeText.voiceRecord = {};
    this.saveVoiceRecord.emit({
      acceptAceptation: this.fieldTypeText.acceptAceptation,
      voiceRecordFile: null,
      name: ''
    })
    this.fieldTypeTextParent.resetInput(this);
  }

  getAudio(){
    let url:string = 'file='+ this.field.evaluatedValue.documents[0].editPath;
    this.apiService.getBlob('utils/file/download?' + url)
      .then((data:any) => {
        this.fieldTypeText.voiceRecord.recordingFile = data.blob;
        let blobUrl: string = URL.createObjectURL(data.blob);
        this.fieldTypeText.voiceRecord.player = new Audio();
        this.fieldTypeText.voiceRecord.player.src = blobUrl
        this.getDuration(blobUrl)
          .then((duration:any)=>{
            this.fieldTypeText.voiceRecord.secondsRecord = duration.toFixed(2);
            this.fieldTypeText.audioLoaded = true;
            this.fieldTypeText.hasVoiceRecord = true;
            this.fieldTypeText.loadFromBack = true;
            this.initInterval = 0;
            this.initStartAudio();
          })
        $(this.fieldTypeText.voiceRecord.player).on("loadedmetadata", ()=>{});
      }, (error:any) => {})
  }

  getDuration(src:any) {
    return new Promise(function(resolve) {
        var audio = new Audio();
        $(audio).on("loadedmetadata", function(){
            resolve(audio.duration);
        });
        audio.src = src;
    });
  }

  initStartAudio(){
    this.fieldTypeText.voiceRecord.player.play();
    this.interval = setInterval(() => {
      this.percentTime = this.initInterval * 100 / this.fieldTypeText.voiceRecord.secondsRecord;
      if(this.percentTime >= 100){
        this.stopInterval()
      }else{
        this.initInterval++
      }
    }, 1000);
    this.startAudio = true;
  }

  stopInterval(){
    this.startAudio = false;
    this.initInterval = 0;
    this.percentTime = 0;
    this.fieldTypeText.voiceRecord.player.pause();
    this.fieldTypeText.voiceRecord.player.currentTime = 0;
    clearInterval(this.interval)
  }

  audioDownLoad(){
    if((this.fieldTypeText.loadFromBack || this.fieldTypeText.audioLoaded) && !this.fieldTypeText.lockedSavedConcept){
      const url = URL.createObjectURL(this.fieldTypeText.voiceRecord.recordingFile);
      const anchor = document.createElement("a");
      anchor.download = this.fieldTypeText.voiceRecord.name;
      anchor.href = url;
      anchor.click();
    }
  }

  acceptAceptationTerms(){
    if(!this.field.noEditable){
      this.fieldTypeText.acceptAceptation = !this.fieldTypeText.acceptAceptation;
      if(this.fieldTypeText.acceptAceptation){
        this.field.errorInAcceptAceptation = false;
      }

      this.saveVoiceRecord.emit({
        acceptAceptation: this.fieldTypeText.acceptAceptation,
        voiceRecordFile: this.fieldTypeText.voiceRecord.file,
        name: this.fieldTypeText.voiceRecord.name
      })
    }
  }
  openIaAssistance(){
    this.fieldTypeTextParent.openIaAssistance(this);
  }
}

